export default "__VITE_ASSET__DBLRGw$2__"